export default __webpack_public_path__ + "static/media/largestaminapot.efff87b2.PNG";